import React, { useEffect, useState } from 'react';
import Cookies from 'js-cookie';
import { Button, Paper } from '@mui/material';
import Select from 'react-select';
import { useFormik } from 'formik';
import * as Yup from "yup";
import { FocusError } from 'focus-formik-error';
import { useDispatch, useSelector } from 'react-redux';
import { BeatLoader } from 'react-spinners';
// import toast, { Toaster } from 'react-hot-toast';
import axios from 'axios';
import { toast } from 'react-toastify';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { getCustomerProfileData, getCustomerProfileDocumentFields } from '../../../Redux/action/Admin/CustomerAction.js';

import { adminMainUrl } from "../../../Config.jsx";

const Documentation = ({ loadingCustomerProfileDataApi, CustomerProfileDataError, CustomerProfileData, disbaledProfileEditing }) => {
  let [disable, setDisable] = useState(false);
  let [showLoader, setShowLoader] = useState(true);
  const [filePreviews, setFilePreviews] = useState({});
  const [fileNames, setFileNames] = useState({});
  const dispatch = useDispatch();

  useEffect(() => {

    dispatch(getCustomerProfileDocumentFields())

  }, []);

  let {


    loadingCustomerProfileDocumentFieldsApi,
    CustomerProfileDocumentFieldsError,
    CustomerProfileDocumentFields,


  } = useSelector(state => state?.CustomerReducer);


  const validDocumentFields = Array.isArray(CustomerProfileDocumentFields?.data) ? CustomerProfileDocumentFields?.data : [];

  const validationSchema = CustomerProfileDocumentFields?.data?.reduce((schema, field) => {
    if (field.mandatory) {
      schema[field.name] = Yup.mixed().required(`${field.name} is required`);
    }
    return schema;
  }, {});
  // Initialize Formik
  const formik = useFormik({
    initialValues: validDocumentFields?.reduce((values, field) => {
      values[field.name] = null; // Initialize as null for file upload
      return values;
    }, {}),
    validationSchema: Yup.object(validationSchema),
    onSubmit: (values, { resetForm }) => {
      setDisable(true);
      try {
        console.log(values);

        const token = Cookies.get('customertoken');

        let config = {
          headers: {
            "auth-token": token,
            'Content-Type': 'multipart/form-data', // Ensure multipart/form-data
          },
        };

        axios.post(`${adminMainUrl}/api/customer-profile/document-create`, values, config)
          .then(res => {
            if (res.status === 200) {
              resetForm();
              toast.success(res.data.msg);
              setDisable(false);
              dispatch(getCustomerProfileData(token))

            } else {
              toast.error(res.data.msg);
              setDisable(false);
            }
          }).catch(err => {
            console.log(err);
            if (err.response) {
              toast.error(err.response.data.msg);
            } else {
              toast.error("Internal server error.")
            }
            setDisable(false);
          });

      } catch (error) {
        console.log(error);
        toast.error(error.response.data.msg);
        setDisable(false);
      }
    },
  });

  // Handle file selection and generate image preview
  // const handleFileChange = (event, fieldName) => {
  //   const file = event.target.files[0];
  //   formik.setFieldValue(fieldName, file);

  //   if (file) {
  //     const isImage = file.type.startsWith('image/');
  //     const filePreview = isImage ? URL.createObjectURL(file) : null;

  //     setFilePreviews((prev) => ({
  //       ...prev,
  //       [fieldName]: filePreview,
  //     }));

  //     setFileNames((prev) => ({
  //       ...prev,
  //       [fieldName]: file.name,
  //     }));
  //   } else {
  //     // Clear preview and file name if no file is selected
  //     setFilePreviews((prev) => ({
  //       ...prev,
  //       [fieldName]: null,
  //     }));
  //     setFileNames((prev) => ({
  //       ...prev,
  //       [fieldName]: null,
  //     }));
  //   }
  // };
  const handleFileChange = (event, fieldName,acceptValues) => {
    const file = event.target.files[0];

    if (file) {
      // Check if file size exceeds 10MB (10 * 1024 * 1024 bytes)
      const fileExtension = `.${file.name.split('.').pop().toLowerCase()}`;

      // Check if the file type is allowed
      if (!acceptValues.includes(fileExtension)) {
        toast.error(
          `Please upload a correct file. Allowed file types: ${acceptValues.join(', ')}.`
        );
        return; // Exit if file type is not allowed
      }
      if (file.size > 10 * 1024 * 1024) {
        toast.error("Max allowed file size is 10MB.");
        return; // Exit the function if the file is too large
      }

      formik.setFieldValue(fieldName, file);

      const isImage = file.type.startsWith('image/');
      const filePreview = isImage ? URL.createObjectURL(file) : null;

      setFilePreviews((prev) => ({
        ...prev,
        [fieldName]: filePreview,
      }));

      setFileNames((prev) => ({
        ...prev,
        [fieldName]: file.name,
      }));
    } else {
      // Clear preview and file name if no file is selected
      setFilePreviews((prev) => ({
        ...prev,
        [fieldName]: null,
      }));
      setFileNames((prev) => ({
        ...prev,
        [fieldName]: null,
      }));
    }
  };


  // Set form values and file previews if data is coming from CustomerProfileData
  useEffect(() => {
    if (CustomerProfileData && CustomerProfileData?.CustomerDocuments) {
      const initialValues = {};
      const filePreviewNames = {};
      const filePreviews = {};

      CustomerProfileData?.CustomerDocuments?.forEach(doc => {
        // Set form values with the document path
        initialValues[doc.documentName] = doc.image;

        // Check if the document is an image based on file extension
        const fileName = doc.image.split('/').pop();
        const isImage = /\.(jpg|jpeg|png|gif|bmp)$/i.test(fileName);

        // Store file name and optionally file preview URL for images
        filePreviewNames[doc.documentName] = fileName;
        if (isImage) {
          filePreviews[doc.documentName] = `${adminMainUrl}/${doc.image}`; // URL for image preview
        }
      });

      formik.setValues(initialValues); // Set form values
      setFileNames(filePreviewNames);  // Set file names for display
      setFilePreviews(filePreviews);   // Set image preview URLs for display
    }
  }, [CustomerProfileData]);




  return (
    <>
      {/* <Toaster /> */}
      {

        <div id="section2" className="section2 w-100 customer_main_detail_form">
          <form onSubmit={formik.handleSubmit} className='p-4'>
            <div className='form-heading-bg'>
              <span>Documentation</span>

            </div>
            {validDocumentFields?.length > 0 ?
              <div className="row">
                {validDocumentFields?.map((field) => (
                  <div key={field.id} className="col-md-6">
                    <div className="mb-3">
                      <label className="form-label">
                        {field.name}
                        {field.mandatory && <span className='text-danger'>*</span>}
                      </label>
                      {!disbaledProfileEditing && <div className="custom-file-container">
                        <label className="custom-file-container__custom-file">
                          <i className="fa-solid fa-upload"></i> Upload Files
                          <input
                            type="file"
                            className="custom-file-container__custom-file__custom-file-input d-none"
                            accept={JSON.parse(field.doucumentFormat).join(",")}
                            onChange={(event) => handleFileChange(event, field.name,JSON.parse(field.doucumentFormat))}
                          />
                          <span className="custom-file-container__custom-file__custom-file-control"></span>
                        </label>
                      </div>}
                    </div>
                    {formik.touched[field.name] && formik.errors[field.name] ? (
                      <div className="text-danger small">{formik.errors[field.name]}</div>
                    ) : null}

                    {fileNames[field.name] && (
                      <p className="selected-file-text">Selected file: {fileNames[field.name]}</p>
                    )}

                    {filePreviews[field.name] ? (
                      <img
                        src={filePreviews[field.name]}
                        alt="File preview"
                        className="file-preview"
                        style={{ width: "100px", height: "100px", margin: "5px" }}
                      />
                    ) : null}
                  </div>
                ))}
              </div>
              :
              <div className='text-center'>No documents found</div>}

            {!disbaledProfileEditing && <Paper className='h-100 d-flex flex-col justify-content-end w-100' square elevation={0} >

              <div className='button-container' style={{ marginTop: '20px' }}>

                <Button
                  className='btn-stepper  btn btn-primary'
                  variant="contained"
                  type='submit'
                  disabled={disable}

                >
                  {!disable ? "Update" : <i className="fas fa-spinner fa-spin" style={{ color: "#fff" }}></i>}
                </Button>
              </div>
            </Paper>}
          </form>
        </div >

      }
    </>

  )
}

export default Documentation